import {Component, forwardRef, OnChanges, SimpleChanges, ChangeDetectorRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, NG_VALIDATORS } from '@angular/forms';
import { DatePickerModel } from '../datepicker.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import * as moment from 'moment';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { IntlService } from '@progress/kendo-angular-intl';
import { COMPONENT_UI } from '../../workflow-components.models';

@Component({
    selector: 'abw-datepicker-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: DatePickerFormComponent,
        multi: true
      }
    ],
    templateUrl: './datepicker-form.component.html',
    styleUrls: ['./datepicker-form.component.scss']
})
export class DatePickerFormComponent extends AbstractWorkflowFormComponent<DatePickerModel, string> implements ControlValueAccessor {
  parsedDate: Date;
  writeValue(value: string) {
    let dateMoment: any;
    const dateFormat = (this.model as any).additional.DATE_FORMAT ?? 'YYYY-MM-DD';

    if (!!dateFormat) {
      dateMoment = moment(value, dateFormat);
    }

    if (!!dateMoment) {
      if (!dateMoment.isValid()) {
        dateMoment = moment(value);
      }

      if (!!dateFormat) {
          value = dateMoment.format(dateFormat);
      }

      this.parsedDate = dateMoment.toDate();
      this.value = value; 
    }
  }

	validate({ value }: FormControl) {
    let dateMoment = moment(value);

    const dateFormat = (this.model as any).additional.DATE_FORMAT ?? 'YYYY-MM-DD';
    if (!!dateFormat) {
      dateMoment = moment(value, dateFormat);
    }
    
		const isValid = (this.model as any).required && !dateMoment.isValid();
		return isValid && {
		  	invalid: true
		};
	}

  onDateChanged(e: any) {
    let rawValue: any;
    if (this.model.componentUI == COMPONENT_UI.MATERIAL)  {
      rawValue = e.value;
    } else if (this.model.componentUI == COMPONENT_UI.IONIC) {
      rawValue = e.detail.value;
    } else if (this.model.componentUI == COMPONENT_UI.KENDO) {
      rawValue = e;
    }

    const dateMoment = moment(rawValue);

    let inputDate: any = dateMoment.toDate();
    if (!!(this.model as any).additional.DATE_FORMAT) {
      inputDate = dateMoment.format((this.model as any).additional.DATE_FORMAT);
    }
    
    this.parsedDate = dateMoment.toDate();
    this.onValueChanged(inputDate);
  }
}